import React, { useState } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Alert,
    CircularProgress,
} from "@mui/material";
import StudentDashboard from "../components/ManageStudents/StudentDashboard/StudentDashboard"; // ⬅️ Import child viewer component

const StudentAccessPortal = () => {
    const [studentId, setStudentId] = useState("");
    const [fullName, setFullName] = useState("");
    const [pin, setPin] = useState("");
    const [error, setError] = useState("");
    const [credentials, setCredentials] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleAccess = async () => {
        setError("");
        setLoading(true);

        if (!studentId || !fullName || !pin) {
            setError("Please fill in all fields.");
            setLoading(false);
            return;
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/grades/public-dashboard/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    student_id: studentId,
                    full_name: fullName,
                    pin: pin,
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || "Access failed.");
            }

            // ✅ Valid student — pass credentials
            setCredentials({ studentId, fullName, pin });
        } catch (err) {
            console.error("❌", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // ✅ If credentials are set, show dashboard view
    if (credentials) {
        return (
            <StudentDashboard
                studentId={credentials.studentId}
                fullName={credentials.fullName}
                pin={credentials.pin}
            />
        );
    }

    // ⬇️ Otherwise show login form
    return (
        <Box sx={{ maxWidth: 500, mx: "auto", mt: 4, p: 3 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    🔐 Student Progress Viewer
                </Typography>

                <TextField
                    fullWidth
                    label="Student ID"
                    value={studentId}
                    onChange={(e) => setStudentId(e.target.value)}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Full Name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="PIN Code"
                    value={pin}
                    onChange={(e) => setPin(e.target.value)}
                    type="password"
                    margin="normal"
                />

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleAccess}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : "Access Dashboard"}
                </Button>

                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
            </Paper>
        </Box>
    );
};

export default StudentAccessPortal;
